








import { Component, Vue } from 'vue-property-decorator'
import { ICellRendererComp } from 'ag-grid-community'
import { FilterType } from '@/module/graphql'
import gql from 'graphql-tag'
import { ICustomRendererCellRendererParams } from '@/module/components/lolth-explorer/supports'
import util from '@/d2admin/libs/util'
import _ from 'lodash'

@Component
export default class CmpUsersCellRenderer extends Vue implements ICellRendererComp {
  private params!: ICustomRendererCellRendererParams
  private users: any[] = []

  created(): void {
    this.refresh(this.params)
  }

  getGui(): HTMLElement {
    return document.createElement('div')
  }

  refresh(params: ICustomRendererCellRendererParams): boolean {
    let users = this.params.value
    if (!users || users.length <= 0) return
    if (_.isPlainObject(users)) {
      // user object
      this.users.push(users)
    } else if (_.isArray(users) && _.isPlainObject(users[0])) {
      // user array
      this.users.push(...users)
    } else {
      // user id / ids
      if (!_.isArray(users)) users = [users]

      this.$apollo.query({
        query: gql`query Users($rowRequest: RowRequest!) {
        Users(rowRequest: $rowRequest) {
          rows { id displayName }
        }
      }`,
        variables: {
          rowRequest: {
            filter: {
              filterType: FilterType.Number,
              field: 'id',
              operator: 'in',
              value: users.join(',')
            }
          }
        }
      }).then(data => {
        util.objects.refill(data.data.Users.rows, this.users)
      })
    }
    return true
  }
}
